// <s-install>: "Add to Home Screen" banner.
// Shows ~4s after arrival unless the site already runs from the home screen or the visitor closed it in the last 3 days.
// Chrome/Android: Install triggers the browser's install prompt. iPhone/iPad and other browsers: shows short steps.
const KEY = 'gofigmo-install-dismissed';
const SNOOZE_MS = 3 * 24 * 60 * 60 * 1000;

let deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  deferredPrompt = event;
  document.querySelector('s-install')?.show();
});

class SInstall extends HTMLElement {
  #ac;
  #timer;

  connectedCallback() {
    if (this.#isInstalled() || this.#isSnoozed()) return;
    this.#ac = new AbortController();
    const signal = this.#ac.signal;

    this.querySelector('[data-install]')?.addEventListener('click', () => this.#install(), { signal });
    this.querySelectorAll('[data-close]').forEach((btn) => btn.addEventListener('click', () => this.dismiss(), { signal }));
    window.addEventListener('appinstalled', () => this.dismiss(), { signal });

    this.#timer = setTimeout(() => this.show(), deferredPrompt ? 1500 : 4000);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
  }

  show() {
    if (!this.hidden || this.#isInstalled() || this.#isSnoozed()) return;
    this.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => this.querySelector('[data-card]')?.setAttribute('data-open', '')));
  }

  dismiss() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch {}
    this.hidden = true;
  }

  async #install() {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      deferredPrompt = null;
      if (outcome === 'accepted') this.dismiss();
      return;
    }
    const steps = this.querySelector('[data-steps]');
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    steps.querySelector('[data-ios]').hidden = !isIOS;
    steps.querySelector('[data-other]').hidden = isIOS;
    steps.hidden = false;
  }

  #isInstalled() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }

  #isSnoozed() {
    try {
      const at = Number(localStorage.getItem(KEY));
      return at > 0 && Date.now() - at < SNOOZE_MS;
    } catch {
      return false;
    }
  }
}

if (!customElements.get('s-install')) customElements.define('s-install', SInstall);
